
define('ldsh!modules/emblue/template_savenewcps', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="emblue savenewcps"></div>';

}
return __p
};});

